module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_empty_11_22_01_on.05dc5df2.svg";